/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileActivitiesResponse } from '../../models/profile-activities-response';

export interface ActivitiesByProfileId$Params {

/**
 * Profile id.
 */
  profileId: number;
  offset: number;
  limit: number;
}

export function activitiesByProfileId(http: HttpClient, rootUrl: string, params: ActivitiesByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileActivitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, activitiesByProfileId.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileActivitiesResponse>;
    })
  );
}

activitiesByProfileId.PATH = '/rest/profile/{profileId}/activities/{offset}/{limit}';
